import { Page, PageTitle } from '../../../../components';

let buildConfig = require('../../../../../src/buildSettings.json');

export const ContractDistribution = () => {
  return (
    <Page title="Contract Distribution">
      <PageTitle title="Contract Distribution" />
      <iframe
        height="768"
        title="Contract Distribution"
        style={{ border: 0 }}
        src={`${buildConfig.POWER_APP_VendorContractDistribution}`}
        allow="geolocation; microphone; camera"
      />
    </Page>
  );
};
